'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FormattedMessage',

  mixins: [_utils.I18nCommonMixin],
  propTypes: _utils.commonPropTypes,

  render: function render() {
    var __message = this.props.message;

    var props = (0, _utils.classNameFix)((0, _utils.getPassThroughProps)(this.props));

    return _react2.default.createElement(
      'i18n-string',
      props,
      this._getValue(true)
    );
  }
});
module.exports = exports['default'];